// jshint module: true

import Component from './../../assets/scripts/component/component';
import fireCustomEvent from './../../assets/scripts/modules/fire-custom-event';

const component = 'case-list';
const selector = `.${component}`;

const singleOnly = true;

class CaseList extends Component {

  constructor(name, element, options) {
    super(name, element, options);
  }

  init() {

    this.links = this.element.querySelectorAll('a.case-list__item__title-link');

    for (const link of this.links) {
      link.addEventListener('click', event => this.onClickHandler(event), false);
    }

    window.addEventListener('resize', this.onResizeHandler.bind(this));

  }

  onClickHandler(event) {
    let element = event.target;
    let href = element.href;

    if (!href) {
      element = element.parentNode;
      href = element.href;
    }

    if (!href) {
      return;
    }

    href = href.split('#');
    href = href[href.length - 1];

    const target = this.element.querySelector(`#${href}`);

    if (!target) {
      return;
    }

    event.preventDefault();

    if (target.classList.contains('is-opening') || target.classList.contains('is-closing')) {
      return;
    }

    if (singleOnly) {
      const others = this.element.querySelectorAll('.case-list__item.is-target');

      for (const other of others) {
        if (other !== target) {
          this.fancyCollapse(other);
        }
      }
    }

    if (target.classList.contains('is-opening') || target.classList.contains('is-closing')) {
      return;
    }

    if (target.getAttribute('data-collapsed-height') !== null) {
      this.fancyCollapse(target);
    } else {
      this.fancyExpand(target);
    }

  }

  fancyExpand(element) {
    let timeout;

    if (!element) {
      return;
    }

    element.classList.add('is-opening');

    const content = element.querySelector('.case-list__item__content');
    content.style.opacity = 0;

    const collapsedHeight = element.offsetHeight;
    element.setAttribute('data-collapsed-height', collapsedHeight);

    const expandedHeight = element.scrollHeight;
    element.style.transition = '';
    element.style.height = `${collapsedHeight}px`;

    window.requestAnimationFrame(() => {
      element.style.transition = 'height .4s ease-out';
      content.style.transition = 'opacity .4s ease-out .1s';
      element.style.height = `${expandedHeight}px`;
      content.style.opacity = 1;

      timeout = window.clearTimeout(timeout);
      timeout = window.setTimeout(() => {
        element.classList.remove('is-opening');
      }, 410);
    });

    element.classList.add('is-target');

  }

  fancyCollapse(element) {
    let timeout;

    if (!element) {
      return;
    }

    element.classList.add('is-closing');

    const content = element.querySelector('.case-list__item__content');

    var expandedHeight = element.offsetHeight;
    var collapsedHeight = parseInt(element.getAttribute('data-collapsed-height'), 10) || 70;

    element.style.transition = 'height .3s ease-out .1s';
    content.style.transition = 'opacity .3s ease-out';

    window.requestAnimationFrame(() => {
      element.style.height = `${collapsedHeight}px`;
      content.style.opacity = 0;

      timeout = window.clearTimeout(timeout);
      timeout = window.setTimeout(() => {
        element.classList.remove('is-closing');
        element.classList.remove('is-target');
      }, 420);
    });

    element.removeAttribute('data-collapsed-height');

  }

  onResizeHandler() {
    const element = this.element.querySelector('.case-list__item.is-target');

    if (!element) {
      return;
    }

    window.requestAnimationFrame(() => {
      element.style.height = 'auto';
      element.style.height = `${element.offsetHeight}px`;
    });

  }

}

for (const element of document.querySelectorAll(selector)) {
  element.instance = new CaseList(component, element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/case-list/case-list.js